import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-visitor-confirm',
  templateUrl: './visitor-confirm.component.html',
  styleUrls: ['./visitor-confirm.component.css']
})
export class VisitorConfirmComponent implements OnInit {
    public inOut: string;

    persNo;

    public edit?: Edit;

    public confirming = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.inOut = this.stateService.getStateParams()['inout'];
        this.persNo = this.stateService.getStateParams()['pers_no'];
    }

    private async loadEdit() {
        if (!!this.inOut && !!this.persNo) {
            this.edit = (await this.datatask.Post(118, {
                inout: this.inOut,
                pers_no: this.persNo
            }))[0];
        }
    }

    public async confirmChanges() {
        if (!!this.edit) {
            try {
                this.confirming = true;

                const mergeObj = {
                    ...this.edit,
                    inout: this.inOut
                }

                await this.datatask.Post(119, mergeObj);

                this.stateService.back();
            } finally {
                this.confirming = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    cust_no: string;
    pers_no: string;
    pers_name: string;
    pers_jobtitle: string;
    pers_email: string;
    inout_heading: string;
    visitor_datetime_in: string;
    visitor_datetime_out: string;
    cust_name: string;
    visit_note: string;
}
